var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteractivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interactivity",
    clipPath: "url(#clip0_11272_2750)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3228 30.2593H6.6145C5.18393 30.2593 4.01074 29.0861 4.01074 27.6555V3.64709C4.01074 2.21652 5.18393 1.04333 6.6145 1.04333H18.915C20.3456 1.04333 21.5188 2.21652 21.5188 3.64709V22.9508",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.11621 1.04333L9.82252 3.16225H15.7124L16.4187 1.04333",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.582 27.7992H13.9523",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6183 7.69287H13.9168C14.2041 7.69287 14.4316 7.92631 14.4316 8.20764V9.81179H16.0357C16.317 9.81179 16.5505 10.0452 16.5505 10.3266V12.625C16.5505 12.9124 16.317 13.1398 16.0357 13.1398H14.4316V14.744C14.4316 15.0253 14.1981 15.2587 13.9168 15.2587H11.6183C11.337 15.2587 11.1035 15.0253 11.1035 14.744V13.1398H9.49938C9.21207 13.1398 8.98462 12.9064 8.98462 12.625V10.3266C8.98462 10.0452 9.21806 9.81179 9.49938 9.81179H11.1035V8.20764C11.1035 7.92033 11.337 7.69287 11.6183 7.69287Z",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.4013 36.9569L27.0789 31.0012C26.4444 24.7163 24.2237 21.3463 21.5242 17.8268",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.25 32.3419C16.0772 28.948 17.6155 25.6379 16.0532 23.543L12.3661 20.5382C11.0672 18.9161 12.7911 16.7732 14.6227 17.6471L18.9742 19.9875C20.6682 21.035 21.991 22.8247 21.7576 24.8778",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.01597 17.0365L2.02275 15.4204C1.27455 14.8099 1.15483 13.7025 1.76537 12.9543C2.31605 12.2719 3.27974 12.1163 4.01597 12.5473",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M4.01664 21.5559L1.25127 19.3113C0.503063 18.7008 0.38335 17.5934 0.993886 16.8452C1.59844 16.097 2.71177 15.9833 3.45997 16.5878",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M4.01664 25.123L1.18543 22.8246C0.592849 22.3457 0.497079 21.4658 0.981916 20.8732C1.46077 20.2807 2.34066 20.1909 2.93324 20.6697",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M15.1975 36.957L14.156 35.1314L9.02026 30.259",
    stroke: "#148D9B",
    strokeWidth: 1.23703,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11272_2750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.0001,
    height: 37.111,
    fill: "white",
    transform: "translate(0 0.444458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractivity);
export default __webpack_public_path__ + "static/media/interactivity.df28726dfb1594432637315ffd128654.svg";
export { ForwardRef as ReactComponent };